import {StyleSheet, Platform} from 'react-native';
import {FONTS} from '../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    maincontainer: {
      flex: 1,
      backgroundColor:
        Platform.OS === 'web' ? colors.background : colors.backgroundMuted,
    },
    subcontainer: {
      flex: 1,
      backgroundColor: colors.surface,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
    },
    emailContainer: {
      flex: 1,
      paddingHorizontal: Platform.OS === 'web' ? 0 : 24,
      paddingBottom: 30,
      justifyContent: 'space-between',
    },
    container: {
      paddingHorizontal: Platform.OS === 'web' ? 0 : 24,
      paddingBottom: 5,
    },
    headerView: {
      marginTop: 30,
      marginHorizontal: Platform.OS === 'web' ? 0 : 24,
    },
    title: {
      marginTop: 14,
      lineHeight: 36,
    },
    subtitle: {
      marginTop: 5,
      lineHeight: 24,
    },
    button: {
      flex: 1,
      marginTop: 15,
    },
    flex1Width292: {
      flex: 1,
      maxWidth: 292,
    },
    root: {
      flex: 1,
      marginLeft: Platform.OS === 'web' ? 0 : 20,
      marginRight: Platform.OS === 'web' ? 0 : 20,
    },
    buttonsContainer: {
      bottom: 30,
    },
    mobileInputContainer: {
      flex: 1,
      // flexDirection: 'row',
      marginTop: 15,
      marginBottom: Platform.OS === 'web' ? 48 : 0,
    },
    titleStyle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 16,
      lineHeight: 24,
      color: colors.textMuted,
      marginTop: 30,
    },
    inputTitleView: {
      width: '75%',
      marginLeft: 15,
    },
    countrySubView: {
      alignItems: 'center',
      marginLeft: 20,
    },
    countryView: {
      height: 50,
      borderRadius: 16,
      flexDirection: 'row',
      width: '20%',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderWidth: 1,
    },
    accessoryContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingVertical: 8,
      backgroundColor: colors.backgroundMuted,
    },
    doneButton: {
      fontFamily: FONTS.mediumFont,
      color: colors.accent,
      fontSize: 16,
    },
  });

export default makeStyles;
